import { render, staticRenderFns } from "./Home_process.vue?vue&type=template&id=272fc0d4&scoped=true&"
import script from "./Home_process.vue?vue&type=script&lang=js&"
export * from "./Home_process.vue?vue&type=script&lang=js&"
import style0 from "./Home_process.vue?vue&type=style&index=0&id=272fc0d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272fc0d4",
  null
  
)

export default component.exports